//
//
//
//
//
//
//
//
//
//
//

import Map from '@/components/views/map'
export default {
    components: {
        'qq-map': Map
    },
    data() {
        return {
            scale: 10
        }
    },
    props: {
        markers: Array,
        show_back: Boolean,
        select_id: [Number, String],
    }
}
